/*! Copyright © 2026 Kontextlab GmbH. All rights reserved. */


export function init() {
        const toggle = document.querySelector('.language-button');
        const panel = document.querySelector('.language-panel');
        if (!toggle || !panel) return;
        toggle.style.display = '';
        toggle.addEventListener('click', (e) => {
            e.stopPropagation();
            panel.classList.toggle('dropped');
            toggle.setAttribute(
                'aria-expanded',
                panel.classList.contains('dropped') ? 'true' : 'false'
            );
        });
}
